import React, { useContext, useEffect, useState } from 'react';
import Sidebar from './sidebar';
import CircularProgress from '../../ui/CircularProgress';
import Question from './Question';
import PageCenter from '../../ui/pageCenter';
import ModalWrapper from '../../ui/modalWrapper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import { addLeadingZero } from '../../utils/helper';
import CustomButton from '../../ui/button';
import SectionDescription from '../../../composants/sectionDescription/description';
import { LoadingContext } from '../../../composants/loadingContext';
import Loader from '../../../composants/loader/Loader';
import axiosInstance from '../../../configurations/axiosInstance/AxiosInstance';
import { useParams } from 'react-router-dom';
import { toastClick } from '../../../composants/toast/CustomToast';

const QuestionScreen = () => {
  const {id}=useParams();
  const {loading, setLoading} = useContext(LoadingContext);
  const [activeQuestion, setActiveQuestion] = useState(0);
  const [sondage, setSondage] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState([]);
  const [showResultModal, setShowResultModal] = useState(false);
  const [result, setResult] = useState([]);
  const [ip, setIp] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  
  const [typeResponse, setTypeResponse] = useState(null);
  const [libelle, setLibelle] = useState(null);
  const [modelResponses, setModelResponses] = useState([]);
  const [quizDetails, setQuizDetails] = useState(
    {
      totalQuestions: 0,
      totalScore: 0,
      totalTime: 0,
    }
  );
  const getIp = async () =>{
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const ips = await response.json();
        setIp(ips.ip);
    } catch (error) {
      setIp(null);
    }
  }
  const timer = 10;
  const fetchSondageById = async ()=>{
    setLoading(true);
    await axiosInstance().get('public/api/sondage/' + id)
            .then(function (response) {
                console.log(response)
              if(response.data != null){
                setSondage(response.data);
                setLoading(false);
                setQuizDetails(
                  {
                    totalQuestions: response.data.questions.length,
                    totalScore: response.data.score,
                    totalTime: 0,
                  }
                )
              }
            })
            .catch(function (error) {
                toastClick("Sondage non existant", "error");
                setLoading(false);
                window.location.href="/";
            });
  }
  useEffect(() => {
    fetchSondageById();
    getIp();
  }, []);
  useEffect(() => {
    if (sondage && sondage.questions) {
      setCurrentQuestion(sondage.questions[activeQuestion]);
      setTypeResponse(sondage.questions[activeQuestion].typeResponse);
      setLibelle(sondage.questions[activeQuestion].libelle);
      setModelResponses(sondage.questions[activeQuestion].modelResponses);
    }
  }, [sondage, activeQuestion]);

  const onClickNext = () => {
    setLoading(true);
    const localResponse = [];
    selectedAnswer.forEach(value=>{ 
        currentQuestion.modelResponses.forEach(response=>{
          if(response.value==value){
            localResponse.push(response)
          }
      })
    });
    let request = result;   
    request.push(
      {
        id: null,
        typeResponse: currentQuestion.typeResponse,
        values: localResponse,
        typeUser: sondage.typeUser,
        questionId: currentQuestion.id,
        sondageId: sondage.id,
        ip: ip,
        userAgent: navigator.userAgent,
        dateTime: null,
    });
    setResult(request);    
    if (activeQuestion !== sondage.questions.length - 1) {
      setActiveQuestion((prev) => prev + 1);
      setLoading(false);
    } else {
      sendResponse(request);
    }
    setSelectedAnswer([]);
  }; 

  const handleAnswerSelection = (e) => {
    const { name, checked } = e.target;
    if (typeResponse === 'QCM') {
      if (selectedAnswer.includes(name)) {
        setSelectedAnswer((prevSelectedAnswer) =>
          prevSelectedAnswer.filter((element) => element !== name)
        );
      } else {
        setSelectedAnswer((prevSelectedAnswer) => [...prevSelectedAnswer, name]);
      }
    }

    if (typeResponse === 'BINAIRY' || typeResponse === 'QCU') {
      if (checked) {
        setSelectedAnswer([name]);
      }
    }
  };

  const handleModal = () => {
    window.location.href='/';
  };


  const sendResponse = async (request) => {
    axiosInstance().post('public/api/sondage/pass', request)
        .then(function (response) {
          setLoading(false);
          setShowResultModal(true);
        })
        .catch(function (error) {
          setLoading(false);
          toastClick("Une erreur est survenue lors de l'enregistrement des reponse de votre sondave. Verifier vos parametres de connexion", 'error');
          //window.location.reload();
        });
  };

  return (
    <>
    {/* {loading && <Loader />} */}
    {loading ? <Loader /> :
    <div style={{paddingTop: 29}}>
    <SectionDescription
        title={sondage?.name}
        subTitle={sondage?.domain[0].domain} />
      
    <div className="grid grid-cols-1 items-start lg:grid-cols-[330px_1fr]">
      <Sidebar
        questions={sondage?.questions}
        activeQuestion={activeQuestion}
        timer={timer}
        quizDetails={quizDetails}
      />

      <PageCenter justifyCenter>
        

        <div className="relative mb-18 min-h-[500px] w-full rounded bg-white p-1 pb-10 md:px-16 md:pt-8 md:pb-20 lg:bg-transparent">
          <div className="mb-7 lg:hidden">
            <CircularProgress
              content={`${addLeadingZero(activeQuestion + 1)}/${addLeadingZero(quizDetails.totalQuestions)}`}
            />
          </div>

          <Question
            libelle={libelle}
            choices={modelResponses}
            type={typeResponse}
            handleAnswerSelection={handleAnswerSelection}
            selectedAnswer={selectedAnswer}
          /> 
          <div className="flex w-[90%] justify-center gap-5 md:w-auto">
            <CustomButton
              text={activeQuestion === sondage?.questions.length - 1 ? 'Finish' : 'Next'}
              onClick={onClickNext}
              icon={<FontAwesomeIcon icon={faArrowCircleRight} />}
              iconPosition="right"
              disabled={selectedAnswer.length === 0}
            />
          </div>
        </div> 

        {(showResultModal) && (
          <ModalWrapper
            title={showResultModal ? 'Done!' : 'Your time is up!'}
            subtitle={`You have attempted ${result.length} questions in total.`}
            onClick={handleModal}
            icon={<FontAwesomeIcon icon={faCheck}/>}
            buttonTitle="Felicitation"
          />
        )}
      </PageCenter>
    </div>
    </div>}

    </>
  );
};

export default QuestionScreen;